import { jsxs, jsx } from 'react/jsx-runtime';
import { addPropsToSVG } from '../helpers/add-props-to-svg.esm.js';

const _SocialInstagram = (props)=>jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            jsx("path", {
                fill: "currentColor",
                d: "M8.6667 12.0001c0 1.8409 1.4923 3.3333 3.3333 3.3333s3.3333-1.4924 3.3333-3.3333c0-1.841-1.4923-3.3334-3.3333-3.3334s-3.3333 1.4924-3.3333 3.3334Z",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            }),
            jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M12 2c-2.7158 0-3.0564.0115-4.123.0602-1.0644.0486-1.7913.2176-2.4274.4648-.6576.2556-1.2153.5975-1.7712 1.1534-.556.556-.8979 1.1136-1.1534 1.7712-.2472.636-.4163 1.363-.4649 2.4274-.0486 1.0666-.0601 1.4072-.0601 4.123s.0115 3.0564.0601 4.123c.0486 1.0644.2177 1.7913.4649 2.4274.2555.6576.5975 1.2152 1.1534 1.7712.556.5559 1.1136.8979 1.7712 1.1534.636.2472 1.363.4163 2.4274.4648 1.0666.0487 1.4072.0602 4.123.0602s3.0564-.0115 4.123-.0602c1.0644-.0485 1.7913-.2176 2.4274-.4648.6576-.2555 1.2152-.5975 1.7712-1.1534.5559-.556.8979-1.1136 1.1534-1.7712.2472-.6361.4163-1.363.4648-2.4274.0487-1.0666.0602-1.4072.0602-4.123s-.0115-3.0564-.0602-4.123c-.0485-1.0644-.2176-1.7913-.4648-2.4274-.2555-.6576-.5975-1.2152-1.1534-1.7712-.556-.5559-1.1136-.8978-1.7712-1.1534-.6361-.2472-1.363-.4162-2.4274-.4648-1.0666-.0487-1.4072-.0602-4.123-.0602Zm6.538 4.662c0 .6627-.5372 1.2-1.2 1.2-.6627 0-1.2-.5373-1.2-1.2s.5373-1.2 1.2-1.2c.6628 0 1.2.5373 1.2 1.2Zm-11.6731 5.3381c0-2.8361 2.299-5.1352 5.1351-5.1352 2.8361 0 5.1351 2.299 5.1351 5.1352 0 2.836-2.299 5.1351-5.1351 5.1351-2.836 0-5.1351-2.2991-5.1351-5.1351Z",
                clipRule: "evenodd",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            }),
            jsx("path", {
                stroke: "currentColor",
                strokeWidth: props.strokeWidth || 1.5,
                d: "M11.9996 12h.0007",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            }),
            jsx("path", {
                stroke: "currentColor",
                strokeWidth: 2,
                d: "M12 11.9999v.0001",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            })
        ]
    });
const SocialInstagram = addPropsToSVG(_SocialInstagram);

export { SocialInstagram };
